import { computed, ref } from "vue";
import { defineStore } from "pinia";

export type ActionPageName =
  | "NOTIFICATION_CENTER_CREATE_NOTIFICATION"
  | "NOTIFICATION_CENTER_EDIT_NOTIFICATION";

export type ActionPage = {
  name: ActionPageName;
  props?: Record<string, unknown>;
};

export const useActionPagesStore = defineStore("action-pages", () => {
  // State
  const _currentActionPage = ref<ActionPage | null>(null);
  const _isAllowed = ref<boolean>(true);

  // Getters
  const currentActionPage = computed(() => _currentActionPage.value);
  const isAllowed = computed(() => _isAllowed.value);

  // Actions
  const setCurrentActionPage = (actionPage: ActionPage) => {
    _currentActionPage.value = actionPage;
    _isAllowed.value = false;
  };

  const clearCurrentActionPage = () => {
    _currentActionPage.value = null;
    _isAllowed.value = true;
  };

  const setIsAllowed = (allowed: boolean) => {
    _isAllowed.value = allowed;
  };

  return {
    currentActionPage,
    isAllowed,
    setCurrentActionPage,
    clearCurrentActionPage,
    setIsAllowed,
  };
});
